<template>
  <div>
    <h1 class="mb-4 font-bold text-3xl">
      Users
    </h1>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <search-filter
        v-model="form.search"
        class="w-full max-w-md mr-4"
        @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">
            With Trashed
          </option>
          <option value="only">
            Only Trashed
          </option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('users.create')">
        <span>Create</span>
        <span class="hidden md:inline">User</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pl-3 pt-6 pb-4">
            Verified?
          </th>
          <th class="px-6 pt-6 pb-4">
            Nama Lengkap
          </th>
          <th class="px-6 pt-6 pb-4">
            Email
          </th>
          <th class="px-6 pt-6 pb-4">
            Nomor Rekening
          </th>
          <th class="px-6 pt-6 pb-4">
            Role
          </th>
          <th class="px-6 pt-6 pb-4" colspan="2">
            Last Update
          </th>
        </tr>
        <tr
          v-for="user in users.data"
          :key="user.id"
          class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t text-center">
            <inertia-link
              class="px-6 py-4 flex items-center focus:text-indigo-500"
              :href="route('users.edit', user.id)">
              <i :class="isEmailVerified(user)" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="px-6 py-4 flex items-center focus:text-indigo-500"
              :href="route('users.edit', user.id)">
              <img
                v-if="user.photo"
                class="block w-5 h-5 rounded-full mr-2 -my-2"
                :src="user.photo">
              {{ user.name }}
              <icon
                v-if="user.deleted_at"
                name="trash"
                class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="px-6 py-4 flex items-center"
              :href="route('users.edit', user.id)"
              tabindex="-1">
              {{ user.email }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="px-6 py-4 flex items-center"
              :href="route('users.edit', user.id)"
              tabindex="-1">
              {{ user.bank_acc_number }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="px-6 py-4 flex items-center"
              :href="route('users.edit', user.id)"
              tabindex="-1">
              {{ user.role }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="px-6 py-4 flex items-center"
              :href="route('users.edit', user.id)"
              tabindex="-1">
              {{ user.updated_at }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link
              class="px-4 flex items-center"
              :href="route('users.edit', user.id)"
              tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="users.length === 0">
          <td class="border-t px-6 py-4" colspan="4">
            No users found.
          </td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="users.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import { Link } from '@inertiajs/vue2'

export default {
    metaInfo: { title: 'Users' },
    components: {
        Icon,
        SearchFilter,
        Pagination,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        filters: Object,
        users: Object,
    },
    data () {
        return {
            form: {
                search: this.filters.search,
                role: this.filters.role,
                trashed: this.filters.trashed,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(this.route('users'), pickBy(this.form), {
                    preserveState: true,
                })
            }, 150),
        },
    },
    methods: {
        reset () {
            this.form = mapValues(this.form, () => null)
        },
        isEmailVerified (user) {
            return user.verified
                ? 'fas fa-check-circle text-green-600'
                : 'fas fa-times-circle text-red-600'
        },
    },
}
</script>
